import React, { useEffect, useState } from 'react';
import { strings } from '../constants/strings';
import { colors } from '../constants/colors';
import { ArrowRight, Sparkles } from 'lucide-react';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-background">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <div className="floating-shape shape-3"></div>
        <div className="pattern-dots"></div>
      </div>
      
      <div className="hero-content">
        <div className={`hero-badge ${isVisible ? 'animate-in' : ''}`}>
          <Sparkles size={16} style={{ color: colors.accent }} />
          <span>White-Label Technology Partner</span>
        </div>
        
        <h1 className={`hero-headline ${isVisible ? 'animate-in' : ''}`}>
          We Power Your <span className="highlight-text">Tech Services</span>. You Scale Revenue.
        </h1>
        
        <p className={`hero-subtext ${isVisible ? 'animate-in' : ''}`}>
          Your technology partner to deliver software services under your brand — without hiring or scaling engineering teams.
        </p>
        
        <div className={`hero-cta ${isVisible ? 'animate-in' : ''}`}>
          <button 
            className="btn-primary"
            onClick={() => scrollToSection('contact')}
          >
            {strings.hero.primaryCta}
            <ArrowRight size={20} />
          </button>
          <button 
            className="btn-secondary"
            onClick={() => scrollToSection('services')}
          >
            {strings.hero.secondaryCta}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
